var render, staticRenderFns
import script from "./Provider.vue?vue&type=script&lang=js&"
export * from "./Provider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9079f8a')) {
      api.createRecord('f9079f8a', component.options)
    } else {
      api.reload('f9079f8a', component.options)
    }
    
  }
}
component.options.__file = "src/modules/tenantProjects/projectControl/Inspection/Provider.vue"
export default component.exports